import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import type { LandingSection } from '../i18n/localizeContent';

export function useLandingSections(page: 'home' | 'about' | 'immigration' | 'contact') {
  const [sections, setSections] = useState<Record<string, LandingSection>>({});
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    try {
      const res = await axios.get<LandingSection[]>('/landing-sections', { params: { page } });
      const map: Record<string, LandingSection> = {};
      res.data.forEach((section) => {
        map[section.sectionKey] = section;
      });
      setSections(map);
    } catch (error) {
      // Falha silenciosa: cada EditableSection cai no fallback estático (i18next) quando a seção não está no mapa.
      setSections({});
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { sections, loading, refetch };
}
